import app, { Component } from 'apprun';
import { isValid, lookup_en } from '../utils';

export default class UserPropertyComponent extends Component {
    view = (state) => {
      if (!state.item) {return;}
      const separator = ':';

      if(state.item.value){
        const dataComponents = state.item.value.split(separator);

        state.entityType = dataComponents[0];
        state.entityId = dataComponents[1] || '';
        state.overrideType = dataComponents[2];
      }

      return (
        <form id="OverrideEditForm" class="form-horizontal" style={{ width: '450px' }}>
          <div class="row">
            <div class="row">
              <span class="col-sm-3">Entity</span>
              <span class="col-sm-6">ID</span>
              <span class="col-sm-3">Override Type</span>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <div class="row">
                  <select id="selectedEntityTpe" name="EntityType" oninput={e => this.run('EntityType-Changed', e)} data-validate>
                    <option value=' '>[Select]</option>
                    {lookup_en.IreOverrideEntityTypeCt.map(r => <option value={r.id} selected={r.value === state.entityType ? 'selected' : null}>{r.value}</option>)}
                  </select>
                </div>
                <div id="selectedEntityTpeErrMsg" class="text-danger row"></div>
              </div>
              <div class="col-sm-6">
                <div class="row">
                  <input id="inpEntityID" class="col-sm-10" value={state.entityId || ''} size="10" oninput={(e) => {state.entityId = e.target.value;}}  data-validate="Int"/>
                </div>
                <div id="inpEntityIDErrMsg" class="text-danger row" ></div>
              </div>
              <div class="col-sm-3">
                <div class="row">
                  <select id="selectedOverrideTpe" name="OverrideTpe" oninput={e => state.overrideType = (e.target.options[e.target.selectedIndex].text)} data-validate>
                    <option value=' '>[Select]</option>
                    {lookup_en.IreOverrideTypeCt.map(r => <option value={r.id} selected={r.value === state.overrideType ? 'selected' : null}>{r.value}</option>)}
                  </select>
                </div>
                <div id="selectedOverrideTpeErrMsg" class="text-danger row"></div>
              </div>

            </div>
          </div>
          <div class="row">
            <div id="inpTextErrMsg" class="text-danger col-sm-12"></div>
          </div>
          <div class="edit-buttons">
            <a
              type="button"
              class="btn btn-primary btn-xs"
              style={(state.item.required || (state.item.value===''))?{ display:'none' }:{ display:'inline-block' }}
              onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
            </a>
            <a
              type="button"
              class="btn btn-primary btn-xs"
              onclick={e => this.run('save', e)}>
            save
            </a>
            <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('cancel')}>
            cancel
            </a>
          </div>
        </form>
      );
    };

  update = {

    save: (state, e) => {
      state.newVal = state.entityType + ':' + state.entityId + ':' + state.overrideType;
      if((!isValid('OverrideEditForm')) || (state.newVal===state.item.value))  { e.preventDefault(); return;}
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },

    cancel: (state) => {
      state.caller.run(state.cancel, state.panelId);
    },

    'EntityType-Changed': (state, e) => {
      const inpEntityID = document.getElementById('inpEntityID') as HTMLInputElement;
      if(this.state.entityType==='PARENT') { this.state.entityId = inpEntityID.value = ''; }
      this.state.entityType = (e.target.options[e.target.selectedIndex].text);
      if((inpEntityID.disabled = (this.state.entityType === 'PARENT'))){ this.state.entityId = inpEntityID.value = '1532';}
    },
  }

  mounted = ({ state }) => state;
}
